import type { components } from '@slims-pro/api-client';
import type { ExtFeatureKey, FeatureKey } from '@slims-pro/client-config';
import type { ProSectionId } from '@slims-pro/ui/organisms';

export type ModuleId = components['schemas']['ModuleId'];

// Compile-time proof that the API's module ids and the UI's section ids are the same set
// (a type, not a const, so no-unused-vars stays quiet).
type Equals<A, B> = [A] extends [B] ? ([B] extends [A] ? true : false) : false;
type Assert<T extends true> = T;
export type AssertModuleIdsMatchSections = Assert<Equals<ModuleId, ProSectionId>>;

export interface ModuleRoute {
	path: string; // equals the id
	title: string; // browser tab title
	/** The route exists only while this feature key is enabled. */
	feature?: FeatureKey | ExtFeatureKey;
}

/**
 * Routing metadata of every module. The pages themselves are in the generated
 * `MODULE_PAGES`, which holds only the client's enabled modules (ADR-017).
 */
export const MODULE_ROUTES: Record<ModuleId, ModuleRoute> = {
	fleet: {
		path: 'fleet',
		title: 'Fleet Multi-Sito',
	},
	single: {
		path: 'single',
		title: 'Impianto Singolo',
	},
	field: {
		path: 'field',
		title: 'Campo Utility-Scale',
	},
	assets: {
		path: 'assets',
		title: 'Asset & Impianti',
	},
	topology: {
		path: 'topology',
		title: 'Cabina Primaria',
	},
	inventory: {
		path: 'inventory',
		title: 'Inventario Ricambi',
	},
	monitor: {
		path: 'monitor',
		title: 'Monitoraggio Energia',
	},
	forecast: {
		path: 'forecast',
		title: 'Previsione',
	},
	design: {
		path: 'design',
		title: 'Dimensionamento FV',
	},
	docs: {
		path: 'docs',
		title: 'Pratiche GSE/STMG',
	},
	anomaly: {
		path: 'anomaly',
		title: 'Rilevamento Anomalie AI',
	},
	solutions: {
		path: 'solutions',
		title: 'Soluzioni Operative',
	},
	predictive: {
		path: 'predictive',
		title: 'Manutenzione Predittiva',
	},
	oman: {
		path: 'oman',
		title: 'Economica O&M',
	},
	rendiconto: {
		path: 'rendiconto',
		title: 'Rendiconto Socio/Cliente',
	},
	warranty: {
		path: 'warranty',
		title: 'Garanzie & Compliance',
	},
	roles: {
		path: 'roles',
		title: 'Accessi & Ruoli',
	},
	reports: {
		path: 'reports',
		title: 'Report Tecnici',
	},
	config: {
		path: 'config',
		title: 'Configurazione',
	},
};
